import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import moment from "moment-timezone";

import {
  useArticles,
  useActionsArticles,
  useDispatchArticleIndex,
} from "../../../../context/inventory/ArticleIndexProvider";
import { FORMAT_DATE_TIME_MOMENT } from "../../../../api/constant";
import LineTitle from "../../../app/atoms/LineTitle";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { ExportAsExcel } from "react-export-table";
import ColumnSearch from "../../../app/atoms/ColumnSearch";
import Pagination from "../../../app/atoms/Pagination";
import { types } from "../../../../reducers/inventory/articlesReducer";
import { OrderColumns } from "../../../app/atoms/OrderColumns";
const initialState = {
  filters: {
    name: "",
    reference: "",
    is_searching_name: false,
    is_searching_reference: false,
    sortBy: "updated_at",
    sortDir: "desc"
  },
};
const ArticleIndex = () => {
  const {
    articles: {
      elements: listArticles,
      rows,
      filter: { page, limit },
    },
  } = useArticles();
  const dispatch = useDispatchArticleIndex();
  const actions = useActionsArticles();
  const [filters, setfilters] = useState(initialState.filters);
  useEffect(() => {
    updateFilter("reference", filters.reference);
  }, [filters.reference]);
  useEffect(() => {
    updateFilter("name", filters.name);
  }, [filters.name]);
  useEffect(() => {
    updateFilter("sortBy", filters.sortBy);
  }, [filters.sortBy]);
  useEffect(() => {
    updateFilter("sortDir", filters.sortDir);
  }, [filters.sortDir]);
  const updateFilter = (field_name, value) => {
    if (filters[field_name].length >= 3) {
      dispatch({
        type: types.CHANGE_INPUT_FILTER_ARTICLES,
        payload: { name: field_name, value: value },
      });
    } else {
      dispatch({
        type: types.CHANGE_INPUT_FILTER_ARTICLES,
        payload: { name: field_name, value: null },
      });
    }
  };
  const cleanFilter = (field_name) => {
    dispatch({
      type: types.CHANGE_INPUT_FILTER_ARTICLES,
      payload: { name: field_name, value: null },
    });
    setfilters({
      ...filters,
      [field_name]: "",
      ["is_searching_" + field_name]: false,
    });
  };

  const filteredDataToExcel = listArticles.map((item) => ({
    id: item.id,
    name: item.name,
    code: item.code,
    created_at: item.created_at
      ? moment(item.created_at).format(FORMAT_DATE_TIME_MOMENT)
      : "",
    has_lote: item.has_lote ? "Si" : "No",
    has_date_expired: item.has_date_expired ? "Si" : "No",
    has_date_made: item.has_date_made ? "Si" : "No",
    description: item.description || "",
    updated_at: item.updated_at
      ? moment(item.updated_at).format(FORMAT_DATE_TIME_MOMENT)
      : "",
  }));

  return (
    <div className="container-fluid">
      <LineTitle title={"Artículos"} />
      <div style={{ marginBottom: "12px" }} className="flex justify-end gap-2">
        <NavLink
          onClick={() => actions.goToArticle(null)}
          to={`/inventory/article/${null}`}
        >
          <div className="btn-default ">
            <FontAwesomeIcon icon={faFileAlt} />
            &nbsp;
            <span>Nuevo</span>
          </div>
        </NavLink>
        <div className="col-md-auto">
          <ExportAsExcel
            data={filteredDataToExcel}
            headers={[
              "ID",
              "Nombre del artículo",
              "Referencia",
              "F. ingreso",
              "Maneja lotes",
              "F. vencimiento",
              "F. fabricación",
              "Descripción",
              "Última edición",
            ]}
            fileName={`Articulos_${moment().format("YYYY-MM-DD_HH-mm-ss")}`}
            name="Articulos"
          >
            {(props) => (
              <div className="flex btn-default" {...props}>
                <FontAwesomeIcon className="margin-auto" icon={faFileExcel} />
                &nbsp;
                <span>Exportar</span>
              </div>
            )}
          </ExportAsExcel>
        </div>
      </div>
      <table className="table table-default-app">
        <thead className="thead-dark">
          <tr>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"ID"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'id', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'id', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col flex">
              <div className="flex">
                {" "}
                <ColumnSearch
                  onChange={(e) =>
                    setfilters({ ...filters, name: e.target.value })
                  }
                  isSearching={filters.is_searching_name}
                  onClickSearch={(e) =>
                    setfilters({
                      ...filters,
                      is_searching_name: !filters.is_searching_name,
                    })
                  }
                  onClickClose={() => cleanFilter("name")}
                  value={filters.name}
                  label={"Nombre del artículo"}
                />
                {" "}
                <OrderColumns
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'name', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'name', sortDir: 'desc' });
                }
                  }
                />
              </div>{" "}
            </th>
            <th scope="col">
              <div className="flex">
                {" "}
                <ColumnSearch
                  onChange={(e) =>
                    setfilters({ ...filters, reference: e.target.value })
                  }
                  onClickSearch={(e) =>
                    setfilters({
                      ...filters,
                      is_searching_reference: !filters.is_searching_reference,
                    })
                  }
                  onClickClose={() => cleanFilter("reference")}
                  value={filters.reference}
                  label={"Referencia"}
                  isSearching={filters.is_searching_reference}
                />
                {" "}
                <OrderColumns
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'code', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'code', sortDir: 'desc' });
                }
                  }
                />
              </div>{" "}
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"F. ingreso"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'created_at', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'created_at', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"Maneja lotes"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'has_lote', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'has_lote', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"F. vencimiento"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'has_date_expired', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'has_date_expired', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"F. fabricación"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'has_date_made', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'has_date_made', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"Descripción"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'description', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'description', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
            <th scope="col">
              <div className="flex">
                <OrderColumns 
                label={"Última edición"}
                sortBy={filters.sortBy}
                sortDir={filters.sortDir}
                onClickAsc={() =>{ 
                    setfilters({ ...filters, sortBy: 'updated_at', sortDir: 'asc' });
                }
                  }
                onClickDesc={() =>
                  { 
                    setfilters({ ...filters, sortBy: 'updated_at', sortDir: 'desc' });
                }
                  }
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {listArticles.map((item) => {
            return (
              <tr key={item.id} onClick={() => actions.goToArticle(item.id)} className="cursor-pointer td-hoverme">
                <td>
                  <span className="cursor-pointer">{item.id}</span>
                </td>
                <td>{item.name}</td>
                <td>{item.code}</td>
                <td className="text-center">
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                    {item.created_at}
                  </Moment>
                </td>
                <td className="text-center">{item.has_lote ? "Si" : "No"}</td>
                <td className="text-center">{item.has_date_expired ? "Si" : "No"}</td>
                <td className="text-center">{item.has_date_made ? "Si" : "No"}</td>

                <td
                  style={{ maxWidth: "14rem" }}
                  className="txt-short"
                  title={item.description}
                >
                  {item.description}
                </td>

                <td className="text-center">
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                    {item.updated_at}
                  </Moment>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-end">
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.CHANGE_INPUT_FILTER_ARTICLES,
              payload: { name: "page", value: e },
            })
          }
          page={page}
          limit={limit}
          rows={rows}
        />
      </div>
    </div>
  );
};
export default ArticleIndex;
